import { render, staticRenderFns } from "./GalleryRanking.vue?vue&type=template&id=23b11283&scoped=true"
import script from "./GalleryRanking.vue?vue&type=script&lang=js"
export * from "./GalleryRanking.vue?vue&type=script&lang=js"
import style0 from "./GalleryRanking.vue?vue&type=style&index=0&id=23b11283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b11283",
  null
  
)

export default component.exports